module.exports = __webpack_public_path__ + "img/logo_yjy.1fcfe2cc.png";